/* =========================================================
   Wellwith theme — Optimized Custom Script
   ========================================================= */
(function () {
  'use strict';

  // 1. Trailing Slash Cleanup (URL bar only)
  if (window.location.pathname.length > 1 && window.location.pathname.endsWith('/')) {
    const newUrl = window.location.pathname.slice(0, -1) + window.location.search + window.location.hash;
    window.history.replaceState({}, document.title, newUrl);
  }

  // 2. Quick Buy Slider Logic (Triggered on Demand)
  let qbIndex = 0;

  function updateSlider() {
    const modal = document.querySelector('.quick-buy-modal') || document.getElementById('quick-buy-content');
    if (!modal) return;

    const gallery = (window.innerWidth < 768) 
      ? modal.querySelector('.mobilegallery') 
      : modal.querySelector('.qb-left:not(.mobilegallery)');

    if (!gallery) return;

    const slides = gallery.querySelectorAll('.qb-slide');
    const thumbs = gallery.querySelectorAll('.qb-thumb');
    if (!slides.length) return;

    if (qbIndex >= slides.length) qbIndex = 0;

    slides.forEach((s, idx) => { s.style.display = (idx === qbIndex) ? 'block' : 'none'; });
    thumbs.forEach((t, idx) => { t.classList.toggle('active', idx === qbIndex); });
  }

  window.qbGoTo = function (el) {
    qbIndex = parseInt(el.dataset.index, 10) || 0;
    updateSlider();
  };

function reConvertQuickBuyModal(container) {
  if (!container) return;
  
  // Scope querySelectorAll to the target container instead of 'document'
  const moneyElements = container.querySelectorAll('.money');
  moneyElements.forEach((el) => {
    el.classList.add('money');
  });

  if (window.bucksCC?.reConvert) {
    window.bucksCC.reConvert();
  }
}

  // 3. Deferred Splide Accessibility Fix (No MutationObserver)
  function fixSplideSlideRoles() {
    document.querySelectorAll('.splide__slide[role="group"]').forEach(slide => {
      slide.setAttribute('role', 'listitem');
      slide.removeAttribute('aria-roledescription');
    });
  }

  // 4. Event Delegation
document.addEventListener('click', function (e) {
  const trigger = e.target.closest('[quick-buy-trigger]');
  if (!trigger) return;

  const modal = document.querySelector('.quick-buy-modal') || document.getElementById('quick-buy-content');
  if (!modal) return;

  let done = false;
  let fallbackTimer; // declared up front, no TDZ risk

  function runUpdate() {
    if (done) return;
    done = true;
    observer.disconnect();
    clearTimeout(fallbackTimer);
    qbIndex = 0;
    updateSlider();
    reConvertQuickBuyModal(modal);
  }

  const observer = new MutationObserver(() => {
    if (modal.querySelector('.qb-slide')) runUpdate();
  });
  observer.observe(modal, { childList: true, subtree: true });

  // in case content is already present
  if (modal.querySelector('.qb-slide')) runUpdate();

  // safety net: stop observing after 1s even if content never shows up
  fallbackTimer = setTimeout(() => observer.disconnect(), 1000);
});

  document.addEventListener('change', function (e) {
    if (e.target.matches('.qb-select')) {
      const form = document.getElementById(e.target.getAttribute('form'));
      if (!form) return;
      const hiddenInput = form.querySelector('input[name="id"]');
      if (hiddenInput) hiddenInput.value = e.target.value;
    }
  });

  // 5. Non-Blocking Initialization
  document.addEventListener('DOMContentLoaded', function () {
    // Run ARIA fix during idle main-thread time
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fixSplideSlideRoles);
    } else {
      setTimeout(fixSplideSlideRoles, 1500);
    }
  });
})();



  //  ======== Button Color css inject in Gokwik sticky cart========== 

// if (window.location.pathname === '/') {

(function () {
  const MAX_ATTEMPTS = 3;
  const RETRY_DELAY = 500;
  let attempts = 0;

  function applyShadowStyle() {
    const host = document.querySelector('shadow-dom-container');

    if (!host || !host.shadowRoot) {
      return false;
    }

    if (!host.shadowRoot.getElementById('gk-btn-style')) {
      const style = document.createElement('style');
      style.id = 'gk-btn-style';
      style.textContent =
        '.sticky-cart button,button.svelte-knso62{color:#fff!important;}';

      host.shadowRoot.appendChild(style);
    }

    return true;
  }

  function retry() {
    if (applyShadowStyle()) {
      return;
    }

    attempts++;

    if (attempts < MAX_ATTEMPTS) {
      setTimeout(retry, RETRY_DELAY);
    }
  }

  function init() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(retry, { timeout: 2000 });
    } else {
      setTimeout(retry, 0);
    }
  }

  if (document.readyState === 'complete') {
    init();
  } else {
    window.addEventListener('load', init, { once: true });
  }
})();

// }